<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 훈련구분 -->
          <c-select
            type="search"
            codeGroupCd="EAP_EVAL_CLASS_CD"
            itemText="codeName"
            itemValue="code"
            name="emergTrainingTypeCd"
            label="LBL0002654"
            v-model="searchParam.emergTrainingTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 훈련구분 -->
          <c-select
            type="search"
            codeGroupCd="EMERG_TRAINING_STATUS_CD"
            itemText="codeName"
            itemValue="code"
            name="emergTrainingStatusCd"
            label="훈련진행 상태"
            v-model="searchParam.emergTrainingStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 훈련기간 -->
          <c-datepicker
            :range="true"
            label="LBL0002655"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="비상대응 훈련 계획/평가 목록"
      rowKey="sopEmergencyTrainingId"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="onItemClick" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'emergencyTrainingPlanResult',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width:60px',
          },
          {
            name: 'emergTrainingName',
            field: 'emergTrainingName',
            label: '훈련명',
            align: 'left',
            sortable: true,
            type: 'link',
            style: 'width:350px',
          },
          {
            name: 'emergTrainingDate',
            field: 'emergTrainingDate',
            label: '훈련기간',
            align: 'center',
            sortable: true,
            style: 'width:150px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '훈련부서',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'emergTrainingTypeName',
            field: 'emergTrainingTypeName',
            label: '훈련구분',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'emergTrainingLoc',
            field: 'emergTrainingLoc',
            label: '훈련장소',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'emergTrainingStatusName',
            field: 'emergTrainingStatusName',
            label: '훈련진행 상태',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'approvalPlanStatusName',
            field: 'approvalPlanStatusName',
            label: '훈련계획 결재상태',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'approvalResultStatusName',
            field: 'approvalResultStatusName',
            label: '훈련평가 결재상태',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        emergTrainingTypeCd: null,
        emergTrainingStatusCd: null,
        useFlag: 'Y',
        startYmd: '',
        endYmd: '',
      },
      period: [],
      searchUrl: '',
      editable: true,
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // code setting
      this.listUrl = selectConfig.sop.eap.planResult.plan.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    onItemClick() {
      this.linkClick(null);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = '비상대응 훈련 계획/평가';
      this.popupOptions.param = {
        emergTrainingPlanId: row ? row.emergTrainingPlanId : '',
        emergTrainingStatusCd: row ? row.emergTrainingStatusCd : '',
        trainingScenarioId: row ? row.trainingScenarioId : '',
      };
      this.popupOptions.target = () => import(`${'./emergencyTrainingPlanResultDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
